import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PathwayState } from './pathway.reducer';

export const selectPathwayState =
  createFeatureSelector<PathwayState>('pathway');

export const pathwaySelector = createSelector(
  selectPathwayState,
  (state) => state.pathway,
);

export const pathwayLoadingSelector = createSelector(
  selectPathwayState,
  (state) => state.loading,
);

export const pathwayLevelsSelector = createSelector(
  pathwaySelector,
  (pathway) => pathway?.levels || [],
);

export const pathwayIdSelector = createSelector(
  pathwaySelector,
  (pathway) => pathway?.pathwayId || null
);
